import { Link } from "react-router-dom";
import { ShieldCheck } from "@phosphor-icons/react";

export const SiteFooter = () => (
  <footer className="mt-24 border-t border-slate-200 bg-white">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 lg:grid-cols-[1.4fr_1fr_1fr] lg:px-8">
      <div>
        <div className="flex items-center gap-2">
          <ShieldCheck size={22} weight="duotone" className="text-navy-800" />
          <span className="font-display text-base font-extrabold text-navy-900">ProductSecurityReady</span>
        </div>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-600">
          Indicative readiness assessments for EU CRA, IEC 62443-4-1, IEC 62443-4-2, the EU Machinery
          Regulation 2023/1230, the UKCA conformity route and UK PSTI, built for product security teams
          at connected-product manufacturers.
        </p>
      </div>
      <div>
        <p className="overline text-navy-800">Frameworks</p>
        <ul className="mt-4 space-y-2 text-sm text-slate-600">
          <li><Link to="/cra-readiness" className="hover:text-navy-800">CRA readiness</Link></li>
          <li><Link to="/iec-62443" className="hover:text-navy-800">IEC 62443-4-1 / 4-2</Link></li>
          <li><Link to="/machinery-ukca" className="hover:text-navy-800">EU MR, UKCA &amp; PSTI</Link></li>
        </ul>
      </div>
      <div>
        <p className="overline text-navy-800">Account</p>
        <ul className="mt-4 space-y-2 text-sm text-slate-600">
          <li><Link to="/login" className="hover:text-navy-800">Log in</Link></li>
          <li><Link to="/register" className="hover:text-navy-800">Create account</Link></li>
          <li><Link to="/dashboard" className="hover:text-navy-800">Product dashboard</Link></li>
        </ul>
        <p className="mt-6 overline text-navy-800">Legal</p>
        <ul className="mt-4 space-y-2 text-sm text-slate-600">
          <li><Link to="/terms" className="hover:text-navy-800" data-testid="footer-terms-link">Terms of service</Link></li>
          <li><Link to="/privacy" className="hover:text-navy-800" data-testid="footer-privacy-link">Privacy notice</Link></li>
          <li><Link to="/refund-policy" className="hover:text-navy-800" data-testid="footer-refund-link">Refund policy</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-200 px-5 py-6 lg:px-8">
      <p className="mx-auto max-w-7xl text-xs leading-relaxed text-slate-500" data-testid="footer-disclaimer">
        Outputs are indicative readiness assessments based on self-reported information. They are not
        certification, legal advice, or a statement of compliance with any regulation or standard.
        No regulation or standard text is reproduced. Accuracy depends on the data you provide, which
        remains your responsibility.
      </p>
    </div>
  </footer>
);
